module.exports = __webpack_public_path__ + "static/img/dialog1.4596904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/dialog1.png
// module id = vfxQ
// module chunks = 0